import React, { useState, useEffect } from "react";
import {
  Button,
  Chip,
  Icon,
  Input,
  Modal,
  Typography,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import theme from "../../theme";
import "./components/modal.scss";

const StyledModal = styled(Modal).attrs()`
  width: 476px;
`;

const DividerDiv = styled.div`
  border: 0.5px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
  margin-bottom: 16px;
`;

const ColorDiv = styled.div`
  width: 95px;
  height: 37px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;

const colorOptions = [
  { label: "Grey", value: "D9D9D9" },
  { label: "Green", value: "345462" },
  { label: "Blue", value: "F3F2FF" },
  { label: "Dark", value: "3E4154" },
  { label: "Pink", value: "FFE6E5" },
  { label: "Brown", value: "5A3E50" },
  { label: "Yellow", value: "FBF8DA" },
];

const EditColorModal = ({ toggleModal, setCustomColor, customColor }) => {
  const [color, setColor] = useState("");
  const [showErr, setShowErr] = useState(false);

  useEffect(() => {
    setColor(customColor ? customColor.slice(1) : "");
  }, [customColor]);

  return (
    <StyledModal
      isOpen={true}
      size="md"
      onClose={() => {
        toggleModal();
      }}
    >
      <Typography
        component="div"
        className="d-flex justify-content-between align-items-center"
      >
        <Typography.H2>Edit Message</Typography.H2>
        <Icon
          iconName="Close"
          onClick={() => {
            toggleModal();
          }}
          size="m"
        />
      </Typography>
      <Typography className="pb-16">
        Choose a background colour of your choice.
      </Typography>

      <div className="d-flex flex-wrap">
        {colorOptions.map((ele) => (
          <div
            key={ele.value}
            className="pb-3 pr-10 text-center"
            onClick={() => setColor(ele.value)}
          >
            <ColorDiv
              color={"#" + ele.value}
              className="p-2"
              style={{
                border:
                  ele.value === color
                    ? `1px solid ${theme.palette.primary.c02}`
                    : "none",
              }}
            >
              {ele.value === color && (
                <Icon
                  iconName="PlumCheckbox"
                  color={theme.palette.primary.c02}
                  className="pt-8"
                />
              )}
            </ColorDiv>
            <Typography.BodySmall>{ele.label}</Typography.BodySmall>
          </div>
        ))}
      </div>

      <DividerDiv />
      <div>
        <Typography.LabelText color="dark" shade="c200" className="mb-4">
          Or Enter hex code
        </Typography.LabelText>
        <Input
          prefix={"#"}
          placeholder="Enter hex code"
          value={color}
          limit={20}
          onChange={(e) => setColor(e.target.value)}
          error={showErr}
          helperText={showErr ? "Button text cannot be left blank." : ""}
        />
      </div>

      <div className="d-flex justify-content-end mt-16">
        <Button
          onClick={() => {
            toggleModal();
          }}
          className="mr-12"
          variant="plain"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            toggleModal();
            setCustomColor("#" + color);
          }}
        >
          Save
        </Button>
      </div>
    </StyledModal>
  );
};

export default EditColorModal;
